import React from 'react';
import { SxProps, CardMedia } from '@mui/material';
import { EntityImage } from './EntityImage';
import { getInitials } from '../utils/getInitials';

export { getInitials };

interface CircularImageProps {
    src?: string | null;
    alt: string;
    size?: number;
    sx?: SxProps;
    circular?: boolean;
}

export const CircularImage: React.FC<CircularImageProps> = ({
    src,
    alt,
    size = 140,
    sx = {},
    circular = true,
}) => {
    const commonStyles = {
        width: `${size}px`,
        height: `${size}px`,
        ...sx,
    };

    if (src) {
        return (
            <CardMedia
                component="img"
                height={size}
                width={size}
                image={src}
                alt={alt}
                sx={{
                    ...commonStyles,
                    objectFit: 'contain',
                    borderRadius: circular ? '50%' : undefined,
                }}
            />
        );
    }

    return (
        <EntityImage
            name={alt}
            size={size}
            shape={circular ? 'circle' : 'square'}
            variant="plain"
            sx={commonStyles}
        />
    );
};
